/**
 * Discord Activity（Phase 2）から起動されたかどうかの判定と、プロキシの prefix。
 *
 * Discord は iframe を開くとき URL に `frame_id` `instance_id` `platform`
 * `guild_id` `channel_id` を付ける。**判定に Embedded App SDK は要らない**ので
 * ここは同期で決まり、SDK の読み込みを待たずに接続先を決められる。
 *
 * **クエリは history.pushState で消える**（room.ts の gotoRoom）。だからモジュール
 * 評価時に1回だけ読んで固定する。pushState が走るのは React の描画後なので、
 * どのモジュールから import されても値は取れている。
 *
 * → doc/service/master.md#phase-2-discord-activity
 */

const params = new URLSearchParams(location.search)

/** Discord の iframe の中にいるか。素のブラウザなら false（＝Phase 1 の経路） */
export const IS_ACTIVITY = params.has('frame_id')

/**
 * Activity インスタンスの識別子。**同じVCで起動した全員に同じ値が配られる**ので、
 * これがルームIDの素になる。→ room.ts の resolveRoomId
 *
 * 形式は22文字ではないため、そのままではルームIDとして使えない。
 */
export const INSTANCE_ID = params.get('instance_id')

/**
 * 外部ドメインは Discord のプロキシ越しにしか叩けない（CSP が自分のプロキシ
 * ドメインに閉じる）。**Developer Portal の URL Mapping と同じ prefix を書く。**
 *
 *   /.proxy/ws → <worker>.workers.dev
 *   /.proxy/td → json.tarkov.dev
 *
 * `/.proxy/` は現在は必須ではなくなったが後方互換で残っている。既存の doc と
 * 揃えて付けたままにする。
 *
 * SDK の patchUrlMappings（fetch・WebSocket・XHR をグローバルに書き換える）は
 * **使わない。** 外部URLを直書きしたサードパーティ npm を矯正するための機能で、
 * このアプリの外部URLは2つとも自前コードの1箇所に集約されているため、
 * グローバルな書き換えの副作用を負う理由が無い。
 */
export const PROXY_WS = '/.proxy/ws'
export const PROXY_TD = '/.proxy/td'
